export default "__VITE_ASSET__DWzLqMRG__"